var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBucket1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.315,
    height: 29.315,
    viewBox: "0 0 29.315 29.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paint_bucket_1_",
    transform: "translate(-18.9 -18.901)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42844",
    "data-name": "Path 42844",
    d: "M412.351,375.448,414.3,372l1.947,3.448a2.234,2.234,0,0,1,.351,1.148,2.3,2.3,0,0,1-4.6,0A2.233,2.233,0,0,1,412.351,375.448Z",
    transform: "translate(-369.48 -331.778)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(20 20.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(0 3.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42845",
    "data-name": "Path 42845",
    d: "M45.244,93.2,32.047,80,20.673,91.374a2.3,2.3,0,0,0,0,3.25l7.648,7.648a2.3,2.3,0,0,0,3.25,0L42.946,90.9",
    transform: "translate(-20 -80)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42846",
    "data-name": "Path 42846",
    d: "M98.049,28.322,90.737,21.01a3.447,3.447,0,0,0-4.875,4.875L93.174,33.2",
    transform: "translate(-81.127 -20.001)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBucket1);
export default __webpack_public_path__ + "static/media/paint_bucket_1.ec8a8bcecc4b9c433c2d58d8f207c1aa.svg";
export { ForwardRef as ReactComponent };